import { TSchema, Type } from "@fastify/type-provider-typebox";
import { BxError } from "./errors";

export const PollingResponse = <T extends TSchema>(t: T) => Type.Object({
  data: Type.Optional(t),
  keepPolling: Type.Optional(Type.Boolean()),
  errors: Type.Optional(Type.Array(BxError)),
});
export type PollingResponse<T> = {
  data?: T;
  keepPolling?: boolean;
  errors?: BxError[];  
};